var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import { connect } from 'react-redux';
import React, { Component } from 'react';

import { Translate, t } from "../../I18N";



import { getCompatibleTypes } from "../../../shared/propertyTypes";
import { SimilarProperty } from "./SimilarProperty";






class SharedProperties extends Component {
  static findProperty(id, templates) {
    return templates.reduce(
      (found, template) => {var _template$properties;return (
          found || ((_template$properties = template.properties) === null || _template$properties === void 0 ? void 0 : _template$properties.find((p) => p._id === id)));},
      undefined
    );
  }

  getRelationTypeName(relationTypeId) {
    const relationType = relationTypeId ?
    this.props.relationTypes.toJS().find((r) => r._id === relationTypeId) :
    undefined;
    return relationType ? relationType.name : undefined;
  }

  getThesauriName(thesauriId) {
    const thesaurus = thesauriId ?
    this.props.thesauris.toJS().find((thesauri) => thesauri._id === thesauriId) :
    undefined;
    return thesaurus ? thesaurus.name : undefined;
  }

  findSameLabelProperties(label, templates) {
    return templates.
    filter((template) => template._id !== this.props.templateId && template.properties).
    map((template) => {
      const property = (template.properties || []).find(
        (prop) => prop.label.trim().toLowerCase() === label.trim().toLowerCase()
      );
      return (
        property ? { template: template.name, property } : { template: undefined });

    }).
    filter((prop) => prop.template !== undefined);
  }

  render() {
    const { type, content, relationType, inherit, label, templates } = this.props;
    const _templates = templates.toJS();
    const inheritedProperty = SharedProperties.findProperty(inherit === null || inherit === void 0 ? void 0 : inherit.property, _templates);
    const similarProperties = this.findSameLabelProperties(
      label,
      _templates
    ).map((propertyMatch) => {var _property$inherit;
      const { property } = propertyMatch;

      const otherInheritedProperty = SharedProperties.findProperty((_property$inherit =
      property.inherit) === null || _property$inherit === void 0 ? void 0 : _property$inherit.property,
      _templates
      );

      return _objectSpread(_objectSpread({},
      propertyMatch), {}, {
        typeConflict: !getCompatibleTypes(type).includes(property.type),
        relationConflict: relationType && property.relationType !== relationType,
        contentConflict: property.content !== content,
        type: property.type,
        relationTypeName: this.getRelationTypeName(property.relationType),
        thesaurusName: this.getThesauriName(property.content),
        inheritConflict: (inheritedProperty === null || inheritedProperty === void 0 ? void 0 : inheritedProperty.type) !== (otherInheritedProperty === null || otherInheritedProperty === void 0 ? void 0 : otherInheritedProperty.type),
        inheritType: otherInheritedProperty === null || otherInheritedProperty === void 0 ? void 0 : otherInheritedProperty.type });

    });

    const thisTemplateLabel = t('System', 'this template', null, false);
    const thisProperty = {
      template: `${this.props.templateName} (${thisTemplateLabel})`,
      type,
      relationTypeName: this.getRelationTypeName(relationType),
      thesaurusName: this.getThesauriName(content),
      typeConflict: false,
      contentConflict: false,
      relationConflict: false,
      inheritConflict: false,
      inheritType: inheritedProperty === null || inheritedProperty === void 0 ? void 0 : inheritedProperty.type
    };

    const templatesWithSameLabelProperties = [thisProperty, ...similarProperties];
    const hasContent = templatesWithSameLabelProperties.find((prop) => prop.thesaurusName);
    return /*#__PURE__*/(
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("label", { className: "suggestions-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Properties from other templates in the collection using the same label"

      )
      ), /*#__PURE__*/
      _jsx("table", { className: "table" }, void 0, /*#__PURE__*/
      _jsx("thead", {}, void 0, /*#__PURE__*/
      _jsx("tr", {}, void 0, /*#__PURE__*/
      _jsx("th", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Template")
      ), /*#__PURE__*/
      _jsx("th", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Type")
      ),
      hasContent && /*#__PURE__*/
      _jsx("th", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Thesauri"), "/", /*#__PURE__*/_jsx(Translate, {}, void 0, "Entity")
      )

      )
      ), /*#__PURE__*/
      _jsx("tbody", {}, void 0,
      templatesWithSameLabelProperties.map((templateProperty, index) => /*#__PURE__*/
      _jsx(SimilarProperty, { templateProperty: templateProperty }, index)
      )
      )
      )
      ));

  }
}
















export function mapStateToProps(state, props) {
  const propertySchemaElement = state.template.data.properties[props.index];
  const { relationTypes } = state;
  return {
    templates: state.templates,
    thesauris: state.thesauris,
    relationTypes,
    templateName: state.template.data.name,
    templateId: state.template.data._id,
    type: propertySchemaElement.type,
    filter: propertySchemaElement.filter,
    label: propertySchemaElement.label,
    content: propertySchemaElement.content,
    relationType: propertySchemaElement.relationType,
    inherit: propertySchemaElement.inherit
  };
}

export const FilterSuggestions = connect(mapStateToProps)(SharedProperties);